import { useState } from 'react';

/**
 * Custom hook to manage view state for accounting integration
 * Handles switching between home and in-progress views
 */
export const useAccountingIntegrationViewState = () => {
  const [showAccountingIntegrationHome, setShowAccountingIntegrationHome] = useState(true);
  const [showAccountingIntegrationInProgress, setShowAccountingIntegrationInProgress] = useState(false);
  const [organisationName, setOrganisationName] = useState('');

  const showInProgressView = (orgName) => {
    setOrganisationName(orgName);
    setShowAccountingIntegrationInProgress(true);
    setShowAccountingIntegrationHome(false);
  };

  const showHomeView = () => {
    setShowAccountingIntegrationInProgress(false);
    setShowAccountingIntegrationHome(true);
  };

  return {
    showAccountingIntegrationHome,
    showAccountingIntegrationInProgress,
    organisationName,
    showInProgressView,
    showHomeView,
  };
};
